const menu = "_menu_1glhz_8";
const title = "_title_1glhz_74";
const styles = {
  menu,
  title
};
export {
  styles as default,
  menu,
  title
};
//# sourceMappingURL=FloatingMenu.module.css.js.map
